<div class="content-loaf">
  <h2>お知らせ更新</h2>
  <hr />

  <div class="row content-block">
    <div class="col-12">
      <a href="/MembersNews/pkobo_news/admin/index.php" target="_blank">お知らせ管理</a>
    </div>
  </div>
</div>
